import { LinearProgress } from '@mui/material';
import { createContext } from 'react';

import { CurrentUser, useCurrentUserQuery } from 'entities/user';

export interface IAuthContext {
  currentUser: CurrentUser | null;
  isLoading: boolean;
}

interface IAuthProviderProps {
  children: React.ReactNode;
}

const AuthContext = createContext<IAuthContext>({ currentUser: null, isLoading: true });

const AuthProvider = (props: IAuthProviderProps) => {
  const { children } = props;
  const { data: currentUser = null, isLoading } = useCurrentUserQuery();

  return (
    <AuthContext.Provider value={{ currentUser, isLoading }}>
      {isLoading ? <LinearProgress /> : children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
